import { GatheringDataInfoWebComponent } from './component/GatheringDataInfoWebComponent';

export { GatheringDataInfoWebComponent };
